import type { ComponentSingleStyleConfig } from "@chakra-ui/react"

// .bns-label: 11px semibold uppercase, muted.
export const FormLabel: ComponentSingleStyleConfig = {
  baseStyle: {
    color: "textMuted",
    fontFamily: "body",
    fontSize: "3xs",
    fontWeight: "semibold",
    letterSpacing: "wider",
    textTransform: "uppercase",
    lineHeight: "snug",
  },
}
